// extracted by mini-css-extract-plugin
export default {"emptyBlank":"Empty_emptyBlank__c18CR","emptyImg":"Empty_emptyImg__hSh4n","emptyTitle":"Empty_emptyTitle__RX+cM","emptyText":"Empty_emptyText__99SWH"};